import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { Alert, Paper, Typography } from '@mui/material';

import { useLensCandidate } from '~/hooks/apis/reporting/useLensCandidate';

import LensProposalPreview from './LensProposalPreview';

export default function LensCandidateReview({ lensId, candidateId }: { lensId: string; candidateId: string }) {
  const query = useLensCandidate(lensId, candidateId);
  const navigate = useNavigate();
  const location = useLocation();
  const dismiss = () => {
    const params = new URLSearchParams(location.search);
    params.delete('change');
    navigate({ ...location, search: params.toString() }, { replace: true });
  };
  return (
    <Paper variant="outlined" sx={{ p: 2, my: 2 }}>
      <Typography variant="h6">Review draft changes</Typography>
      {query.error && <Alert severity="error">This candidate has expired, changed or is unavailable to you.</Alert>}
      {query.data &&
        (query.data.status === 'current' ? (
          <LensProposalPreview
            proposal={{ ...query.data, status: undefined }}
            onSavedLens={dismiss}
            onDiscard={dismiss}
          />
        ) : (
          <Typography variant="body2">This draft no longer applies to the Lens. Ask again.</Typography>
        ))}
    </Paper>
  );
}
